import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ChevronUp16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8 3.93933L13.5303 9.46966L12.4697 10.5303L8 6.06065L3.53033 10.5303L2.46967 9.46966L8 3.93933Z'
      fill='currentColor'
    />
  </Svg>
);

ChevronUp16.displayName = 'ChevronUp16';
export default ChevronUp16;
